module.exports = __webpack_public_path__ + "img/antes_despues_18.ded7b13f.png";